import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuIcon from "@mui/icons-material/Menu";
import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Modal from '@mui/material/Modal';
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearUser } from "../redux/userSlice";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "80%",
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const Header = ({ heading, symbol }) => {
  const user = useSelector((state) => state.user.user)
  const [openModal, setOpenModal] = useState(false);
  const handleModalOpen = () => setOpenModal(true);
  const handleModalClose = () => setOpenModal(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDeleteAccount  = async () => {
    try {
      await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/users?username=${user.username}`,
        {headers: {Authorization: `Bearer ${user.accessToken}`}}
      )
      dispatch(clearUser())
      navigate('/')
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: 'space-between' }}>
      <Box sx={{display: 'flex', alignItems: 'center'}}>
        <Button
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          sx={{
            padding: 0,
            width: "auto",
            background: "none !important",
            color: "#fff",
          }}
        >
          <MenuIcon />
        </Button>
        <Typography className="heading">{heading}</Typography>
      </Box>
      {symbol ? (
        <Button sx={{width: 'auto', color: '#ffffff', marginRight: "10px !important"}} onClick={handleModalOpen}>
          <DeleteOutlineIcon />
        </Button>
      ) : null}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={handleClose}>
          <StarBorderIcon />
          <Typography sx={{ ml: 1 }}>Rate Us</Typography>
        </MenuItem>
        <MenuItem onClick={handleClose} href="/dashboard/my-profile">
          <a
            href="/dashboard/my-profile"
            style={{ color: "rgba(0, 0, 0, 0.87)", display: "flex" }}
          >
            <PersonOutlineOutlinedIcon />{" "}
            <Typography sx={{ ml: 1 }}>View Profile</Typography>
          </a>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <NotificationsActiveOutlinedIcon />{" "}
          <Typography sx={{ ml: 1 }}>Notifications</Typography>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <HelpOutlineOutlinedIcon />{" "}
          <Typography sx={{ ml: 1 }}>Help</Typography>
        </MenuItem>
      </Menu>

      <Modal
        open={openModal}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2" textAlign={'center'}>
            Are you sure you want to delete your account?
          </Typography>
          <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
            <Button sx={{width: 'auto', color: '#ffffff'}} onClick={handleDeleteAccount}>Yes</Button>
            <Button sx={{width: 'auto', color: '#ffffff'}} onClick={handleModalClose}>No</Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default Header;
